export enum TaskStatus {
  CREATED = 'created',
  COMPLETED = 'completed',
  CANCELLED = 'canceled',
}
